import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector, FormSection, change } from 'redux-form';
import { connect } from 'react-redux';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import { Link } from '@zola/zola-ui';

import { RenderField, RenderTextareaField, RenderSubmitButton, RenderCheckboxRadioField, RenderDatePicker, RenderSelectField, RenderGeosuggest } from '../../../common/form';
import * as Validations from '../../../common/form/commonValidations';
import { TravelTypes, getTravelType, hasTravelField, getTravelFieldLabel, getTravelFieldPlaceholder } from './TravelTypes';
import { getPlaceDetails } from '../../../../actions/website/PlacesActions';
import AddressFields from '../../../common/form/AddressFields';
import { updateTravel, addTravel } from '../../../../actions/website/entities/TravelActions';
import { hideModal } from '../../../../actions/ModalActions';
import { getHours, minutes } from '../../../common/form/timeValues';
import featureFlags from '../../../../util/featureFlags';

class TravelForm extends Component {
  constructor(props) {
    super(props);
    this.toggleAddress = this.toggleAddress.bind(this);
    this.resetType = this.resetType.bind(this);
    this.state = {
      autoAddress: !this.props.initialValues.id
    };
  }

  componentWillReceiveProps(nextProps) {
    const { address, handleAddress } = this.props;
    if (Object.keys(nextProps.address).length > 0 && nextProps.address !== address && !nextProps.address.busy) {
      handleAddress(nextProps.address);
    }
  }

  toggleAddress(suggestion) {
    if (suggestion === undefined) {
      this.setState({ autoAddress: true });
      return;
    }
    if (!suggestion.placeId) {
      this.setState({ autoAddress: false });
    } else {
      this.setState({ autoAddress: !this.state.autoAddress });
    }
  }

  resetType() {
    const { unsetType } = this.props;
    unsetType();
    this.setState({ autoAddress: true });
  }

  render() {
    const { handleSubmit, submitting, valid, type, getSuggestion, address, isUpdate } = this.props;
    const { autoAddress } = this.state;
    return (
      <div className="entity-form">
        <div className="modal-header">
          {type && <Link role="button" arrowPosition="prefix" arrow className="back-button" onClick={this.resetType}>Back</Link>}
          <h3 className="modal-title">
            {!type && <span>Add Travel &amp; Places To Stay</span>}
            {type && `${isUpdate ? 'Edit' : 'Add'} ${getTravelType(type)}`}
          </h3>
        </div>
        <div className="modal-body clearfix">
          <form onSubmit={handleSubmit} id="travel-form" noValidate>
            {!type && TravelTypes.map((travelType, index) => (
              <div key={index} className="travel-type col-sm-3 text-center">
                <label htmlFor={`travel-form-${travelType.value}`}>
                  <h1>
                    <i className={`zolaicon-public zolaicon-public-${travelType.value.toLowerCase()}`} />
                  </h1>
                  {travelType.title}
                </label>
                <Field
                  name="type"
                  type="radio"
                  id={`travel-form-${travelType.value}`}
                  value={travelType.value}
                  component={RenderCheckboxRadioField}
                  validate={Validations.REQUIRED}
                />
              </div>
            ))}
            {type && (
              <div>
                {hasTravelField(type, 'address') && autoAddress && !address.busy && (
                  <div className="form-group">
                    <Field
                      name="name_geo"
                      id="travel-form-name"
                      label={getTravelFieldLabel(type, 'address')}
                      component={RenderGeosuggest}
                      onSuggestSelect={(suggestion) => {
                        if (!suggestion) {
                          return;
                        }
                        getSuggestion(suggestion);
                        this.toggleAddress(suggestion);
                      }}
                      inputClassName="form-control"
                      required
                      validate={[Validations.REQUIRED, Validations.MAX_LENGTH_60]}
                      maxChars={60}
                    />
                    <Link className="pull-right" onClick={this.toggleAddress} role="button">Or Enter Address Manually</Link>
                  </div>
                )}
                {hasTravelField(type, 'name') && (!autoAddress || !hasTravelField(type, 'address')) && (
                  <Field
                    component={RenderField}
                    name="name"
                    id="travel-form-name"
                    label={getTravelFieldLabel(type, 'name')}
                    placeholder={getTravelFieldPlaceholder(type, 'name')}
                    type="text"
                    required
                    validate={[Validations.REQUIRED, Validations.MAX_LENGTH_100]}
                    maxChars={100}
                  />
                )}
                {hasTravelField(type, 'address') && !autoAddress && !address.busy && (
                  <FormSection name="">
                    <AddressFields selector="travelForm" optional />
                  </FormSection>
                )}
                {hasTravelField(type, 'address') && address.busy && (
                  <div className="busy-loader center-block" />
                )}
                {hasTravelField(type, 'url') && (
                  <Field
                    component={RenderField}
                    name="url"
                    id="travel-form-website"
                    label={getTravelFieldLabel(type, 'url')}
                    placeholder="http://"
                    type="url"
                    validate={Validations.MAX_LENGTH_2000}
                  />
                )}
                {hasTravelField(type, 'code') && (
                  <Field
                    name="code"
                    id="travel-form-discount-code"
                    type="text"
                    label={getTravelFieldLabel(type, 'code')}
                    component={RenderField}
                    validate={Validations.MAX_LENGTH_60}
                    placeholder={getTravelFieldPlaceholder(type, 'code')}
                    maxChars={60}
                  />
                )}
                {type === 'SHUTTLE' && (
                  <div className="row">
                    <div className="col-sm-4">
                      <Field
                        component={RenderDatePicker}
                        name="date"
                        label="Event Date"
                        id="event-date"
                        required
                        validate={[Validations.REQUIRED, Validations.DATE, Validations.DATE_WITHIN_VALID_RANGE]}
                      />
                    </div>
                    <div className="col-sm-8 row" style={{ padding: 0 }}>
                      <div className="col-sm-6 start-time">
                        <strong className="form-label">Start Time <span className="text-danger danger-asterisk">*</span></strong>
                        <br />
                        <Field
                          component={RenderSelectField}
                          name="startTimeHrs"
                          id="event-start-time-hrs"
                          options={getHours()}
                          hideEmpty
                          required
                          validate={Validations.REQUIRED}
                        />
                        <Field
                          component={RenderSelectField}
                          name="startTimeMins"
                          id="event-start-time-mins"
                          options={minutes}
                          hideEmpty
                          required
                          validate={Validations.REQUIRED}
                        />
                        <Field
                          component={RenderSelectField}
                          name="startTimeAmPm"
                          id="start-time-am-pm"
                          options={[{ title: 'am', value: 'am' }, { title: 'pm', value: 'pm' }]}
                          hideEmpty
                          required
                          validate={Validations.REQUIRED}
                        />
                      </div>
                      <div className="col-sm-6 end-time">
                        <strong className="form-label">End Time <span className="text-danger danger-asterisk">*</span></strong>
                        <br />
                        <Field
                          component={RenderSelectField}
                          name="endTimeHrs"
                          id="event-end-time-hrs"
                          options={getHours()}
                          hideEmpty
                          required
                          validate={Validations.REQUIRED}
                        />
                        <Field
                          component={RenderSelectField}
                          name="endTimeMins"
                          id="event-end-time-mins"
                          options={minutes}
                          hideEmpty
                          required
                          validate={Validations.REQUIRED}
                        />
                        <Field
                          component={RenderSelectField}
                          name="endTimeAmPm"
                          id="end-time-am-pm"
                          options={[{ title: 'am', value: 'am' }, { title: 'pm', value: 'pm' }]}
                          hideEmpty
                          required
                          validate={Validations.REQUIRED}
                        />
                      </div>
                    </div>
                  </div>
                )}
                <Field
                  component={RenderTextareaField}
                  name="note"
                  id="travel-form-note"
                  label="Note to Guests"
                  placeholder={getTravelFieldPlaceholder(type, 'note')}
                  maxChars={1000}
                  rows={4}
                  validate={Validations.MAX_LENGTH_1000}
                />
                <RenderSubmitButton pristine={false} submitting={submitting} valid={valid} />
              </div>
            )}
          </form>
        </div>
      </div>
    );
  }
}

TravelForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  type: PropTypes.string,
  getSuggestion: PropTypes.func,
  initialValues: PropTypes.shape({
    id: PropTypes.number
  }),
  address: PropTypes.shape({ busy: PropTypes.bool }),
  unsetType: PropTypes.func,
  handleAddress: PropTypes.func,
  isUpdate: PropTypes.bool
};

const formatEventDate = (form) => {
  const dateString = moment.utc(form.date, 'MM-DD-YYYY').format('MM-DD-YYYY');
  const start = moment.utc(`${dateString} ${form.startTimeHrs}:${form.startTimeMins} ${form.startTimeAmPm}`, 'MM-DD-YYYY h:mm a');
  const end = form.endTimeHrs && form.endTimeMins !== '' ? moment.utc(`${dateString} ${form.endTimeHrs}:${form.endTimeMins} ${form.endTimeAmPm}`, 'MM-DD-YYYY h:mm a') : '';
  if (end !== '' && end.isBefore(start)) {
    end.add(1, 'd');
  }
  const startTime = start.format();
  const endTime = end !== '' ? end.format() : undefined;
  return Object.assign({}, form, { start_at: startTime, end_at: endTime, timezone: momentTimezone.tz.guess() });
};

const formatDateForEdit = (form) => {
  if (!form.date) {
    const start = moment.utc(form.start_at);
    const end = moment.utc(form.end_at);
    let endAmPm;
    let endHours;
    if (end.isValid()) {
      endAmPm = end.format('a');
      endHours = end.format('h');
    }
    return {
      date: moment.utc(form.start_at),
      startTimeMins: start.format('m'),
      startTimeHrs: start.format('h'),
      startTimeAmPm: start.format('a'),
      endTimeMins: end.isValid() ? end.format('m') : undefined,
      endTimeHrs: endHours,
      endTimeAmPm: endAmPm
    };
  }
  return undefined;
};

const formatNewDate = (date) => {
  if (date) {
    return moment.utc(date);
  }
  return moment.utc();
};

const TravelFormInstance = reduxForm({
  form: 'travelForm',
})(TravelForm);

const selector = formValueSelector('travelForm');

const mapStateToProps = state => ({
  initialValues: Object.assign(
    {},
    { type: selector(state, 'type') },
    state.website.entities.byId[state.website.entities.selectedEntityId],
    state.website.entities.selectedEntityId && state.website.entities.byId[state.website.entities.selectedEntityId].type === 'SHUTTLE' ? formatDateForEdit(state.website.entities.byId[state.website.entities.selectedEntityId]) : { date: formatNewDate(state.wedding.wedding.wedding_date) },
    state.website.entities.selectedEntityId && state.website.entities.byId[state.website.entities.selectedEntityId].type === 'SHUTTLE' ? {} : { startTimeHrs: '4', startTimeMins: '0', startTimeAmPm: 'pm', endTimeHrs: '10', endTimeMins: '0', endTimeAmPm: 'pm' }
  ),
  type: selector(state, 'type'),
  address: state.website.entities.address
});

const mapDispatchToProps = dispatch => ({
  onSubmit: (travelFormRequest) => {
    let req = travelFormRequest;
    if (travelFormRequest.type === 'SHUTTLE') {
      req = formatEventDate(travelFormRequest);
    }
    if (featureFlags.get('checkGeosuggest')) {
      if (travelFormRequest.name_geo && !travelFormRequest.name) {
        req = Object.assign({}, req, { name: travelFormRequest.name_geo });
      }
    } else if (travelFormRequest.name_geo) {
      req = Object.assign({}, req, { name: travelFormRequest.name_geo });
    }
    if (travelFormRequest.id) {
      dispatch(updateTravel(req));
    } else {
      dispatch(addTravel(req));
    }
    dispatch(hideModal());
  },
  getSuggestion: (suggestionData) => {
    if (suggestionData === undefined) {
      return;
    }
    if (!suggestionData.placeId) {
      return;
    }
    dispatch(getPlaceDetails(suggestionData.placeId, suggestionData.label));
  },
  unsetType: () => dispatch(change('travelForm', 'type', '')),
  handleAddress: (address) => {
    Object.keys(address).filter(key => !!address[key]).map(key => (
      dispatch(change('travelForm', key, address[key]))
    ));
  }
});

const TravelFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TravelFormInstance);

export default TravelFormContainer;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/TravelForm.jsx